、<!--
 * @Description: 收入统计页面
 * @Author: gaohc
 * @Date: 2024-06-10 16:43:52
-->
<template>
  <div class="body">
    <div v-loading="loading" element-loading-text="正在导出...">
      <el-row class="search-row-margin" :gutter="0" type="flex" justify="space-between">
        <el-col :span="7" style="text-align: left">
          <div class="bk-time-tabs">
            <div v-for="(item, index) in timeTabs" :key="item.dateText" @click="handleChangeSharingTimeTab(item, index)"
              :class="item.defaultFilter ? 'search-tab search-tab-active mouse-pointer' 
              : 'search-tab search-tab-inactive mouse-pointer'">
              {{item.dateText}}
            </div>
          </div>
        </el-col>
        <el-col :span="7" style="text-align: center">
          <span class="search-title-wrap">到账时间：</span>
          <el-date-picker v-model="dateRange" style="width: 215px" type="daterange"
            align="right" unlink-panels range-separator="至" size="small" 
            start-placeholder="开始时间" end-placeholder="结束时间" 
            :picker-options="dateRangePickerOptions"
            prefix-icon="el-icon-date" @change="handleChangeDate">
          </el-date-picker>
        </el-col>
        <el-col :span="7" style="text-align: center; line-height: 32px;">
          <span class="search-title-wrap" style="padding-right: 6px;">收入方：</span>
          <span style="width: 215px">
            <el-checkbox v-model="filterParams.incomePersonType" :true-label="2" @change="handleChangeType">机构</el-checkbox>
            <el-checkbox v-model="filterParams.incomePersonType" :true-label="1" @change="handleChangeType">个人</el-checkbox>
          </span>
        </el-col>
        <el-col :span="3" style="text-align: right">
          <el-button size="small" @click="handleSelect" type="primary" icon="el-icon-search"
            class="btn-search-w80">
            搜 索
          </el-button>
        </el-col>
      </el-row>
      <el-row class="search-row2-margin" :gutter="0" type="flex" justify="space-between" >
        <el-col :span="7" style="text-align: left">
          <span class="search-title-wrap">机构名称：</span>
          <el-select v-model="filterParams.institutionId" clearable filterable size="small"
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
              srcInstitutionList, this))"
            @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
              'institutionList', srcInstitutionList, this)"
            placeholder="请输入/选择" style="width: 215px">
            <el-option v-for="item in institutionList" :key="item.id"
              :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" style="text-align: center">
          <span class="search-title-wrap">人员信息：</span>
          <el-input v-model="filterParams.attendantNameOrMobile" :disabled="filterParams.incomePersonType == 2" size="small"
            clearable style="width: 215px" placeholder="姓名/手机号">
          </el-input>
        </el-col>
        <el-col :span="10" style="text-align: right">
          <el-button size="small" plain type="primary" class="btn-search-w80" 
            style="background: #FEFFFF; color: #3E7EF5;"
            v-if="dataPvgList.includes('INCOME_4_SHARING_EXPORT')" 
            @click="handleExport">
            <el-image :src="require('@/assets/report/icon-report-export.png')" fit="cover" 
              style="width: 12px; height: 12px; margin-right: 6px; vertical-align: bottom;">
            </el-image>
            导 出
          </el-button>
        </el-col>
      </el-row>
      <div class="main-page-divider"></div>
      
      <div class="report-main">
        <div class="report-bar">
          <div class="title">收入趋势分析</div>
          <bar-charts v-if="xAxisData.length && amountChartMap.length" 
            id="bar-area" :chartData="{xAxisData: xAxisData, amountChartMap: amountChartMap}" />
          <el-empty v-else description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  
      <el-table class="table-common-style" :style="tableWidth" :data="dataTable"
        style="margin: 20px 40px;"
        :header-cell-style="{'background-color': '#EFF5FA'}">
        <el-table-column label="所属机构" min-width="15%" align="left">
          <template slot-scope="scope">
            <span class="overflow-text-style">{{scope.row.institutionName || '- -' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="incomePersonText" label="收入方" min-width="12%" align="left"
          v-if="showIncomePersonText" :key="1">
          <template slot-scope="scope">
            <span class="overflow-text-style">{{scope.row.incomePersonText || '- -' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="incomeAccount" label="收入账户" 
          min-width="12%" align="left" :key="2">
          <template slot-scope="scope">
            {{scope.row.incomeAccount ? scope.row.incomeAccount : '- -'}}
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="收入总额 (元)" min-width="15%" align="left"
          :sortable="true" :sort-method="sortMethod" :key="6">
          <template slot-scope="scope">
            <span>{{scope.row.totalAmount ? scope.row.totalAmount : '- -'}}</span>
            <span v-if="parseFloat(scope.row.totalAmount)" class="details-text"
              @click="handleSeeIncomeDetails(scope.row)">
              明细
            </span>
          </template>
        </el-table-column>
        <el-table-column label="可提现总额 (元)" prop="canWithdrawAmount"
          :sortable="true" :sort-method="sortMethodCanWithdrawAmount"
          min-width="12%" align="left" :key="7">
          <template slot-scope="scope">
            {{scope.row.canWithdrawAmount ? scope.row.canWithdrawAmount : "- -"}}
          </template>
        </el-table-column>
        <el-table-column label="已提现总额 (元)" prop="withdrawnAmount"
          :sortable="true" :sort-method="sortMethodWithdrawnAmount"
          min-width="12%" align="left" :key="8">
          <template slot-scope="scope">
            {{scope.row.withdrawnAmount ? scope.row.withdrawnAmount : "- -"}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="8%" align="left"
          v-if="!showIncomePersonText" :key="3">
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              width="500"
              trigger="click">
              <div style="max-height: 200px; overflow-y: auto;">
                <el-table style="border: 1px solid #f0f0f0;" :data="scope.row.hospitalIncomeList"
                :header-cell-style="{'background-color': '#EFF5FA'}">
                <el-table-column min-width="50%" property="hospitalName" label="服务医院"></el-table-column>
                <el-table-column min-width="40%" property="name" sortable label="收入总额 (元)">
                  <template slot-scope="scpe">
                      <span>{{scpe.row.totalAmount ? scpe.row.totalAmount : '- -'}}</span>
                      <span v-if="parseFloat(scpe.row.totalAmount)" class="details-text"
                        @click="handleSeeIncomeDetails(scpe.row)">
                        明细
                      </span>
                  </template>
                </el-table-column>
              </el-table>
              </div>
              <el-button type="text" size="small"
                slot="reference">
                详情
              </el-button>
            </el-popover>
        </template>
      </el-table-column>
      </el-table>
      <el-row class="foot-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
          :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
          layout="total,prev, pager, next, sizes, jumper" :total="totalNumber"/>
      </el-row>

      <!-- 收入详细Dlg -->
      <income-details-dlg :visible="incomeDetailsVisible" :incomeItem="incomeItem"
        :begDate="filterParams.begDate" :endDate="filterParams.endDate"
        @close-dialog="incomeDetailsVisible = false" />
    </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import Util from "@/global/Util.js";
import BarCharts from "./components/BarCharts.vue";
import IncomeDetails from "./components/IncomeDetails.vue";

export default {
  name: "IncomeReport",

  components: {
    'bar-charts': BarCharts,
    'income-details-dlg': IncomeDetails
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
        incomePersonType: 2,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      institutionList: [],
      srcInstitutionList: [],

      dataTable: [],
      timeTabs: [],

      dateRange: null,
      dateRangePickerOptions: {
				disabledDate(time) {
          return time.getTime() > Date.now(); 
        }
			},

      xAxisData: [],
      amountChartMap: [],
      pieChartDOList: [],
      endDate: "",
      startDate: "",
      paymentPlatform: '',
      loading: false,

      showIncomeAccount: false,     //是否顯示收入賬戶
      showIncomePersonText: false,  //是否显示收入方名称

      incomeItem: {},
      incomeDetailsVisible: false
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    }
  },

  methods: {
    async initView() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      this.getOrederReportList();
      this.getOrederReportChat();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INCOME'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //获取过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_INCOME_REPORT_FILTER_DO).then((result) => {
          if (result == null) {
            return;
          }

          this.institutionList = result.data.institutionList;
          this.srcInstitutionList = result.data.institutionList;
          this.timeTabs = result.data.dateFilterList;
          this.getDefaultDateRange(result.data.dateFilterList);
          resolve();
        })
      });
    },

    getDefaultDateRange(data) {
      data.forEach(item => {
        if (item.defaultFilter) {
          this.filterParams.timeSlot = item.timeSlot;
          this.dateRange = [item.begDate, item.endDate];
          this.filterParams.begDate = this.dateRange && this.dateRange.length 
            ? this.dateUtil.dateFormat(this.dateRange[0]) : '';
          this.filterParams.endDate = this.dateRange && this.dateRange.length 
            ? this.dateUtil.dateFormat(this.dateRange[1]) : '';
        }
      })
      console.log(this.filterParams.timeSlot)
    },
    
    //订单统计列表接口调用
    getOrederReportList() {
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_PAGE_INCOMES,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }

        this.dataTable = result.data || [];
        this.totalNumber = result.totalNumber || 0;

        if (this.filterParams.incomePersonType == 1) {
          this.showIncomePersonText = true;
        } else {
          this.showIncomePersonText = false;
        }
      });
    },

    //统计chat接口调用
    getOrederReportChat() {
      let params = {...this.filterParams}
      delete params.page
      delete params.pageSize
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_INCOME_REPORT_DO,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }

        this.xAxisData = Object.keys(result.data.amountChartMap);
        this.amountChartMap = Object.values(result.data.amountChartMap);
        this.pieChartDOList = this.convertData(result.data.pieChartDOList);

        this.startDate = result.data.startDate
          ? this.dateUtil.dateFormat(result.data.startDate) : "";
        this.endDate = result.data.endDate 
          ? this.dateUtil.dateFormat(result.data.endDate) : "";
      });
    },

    convertData(data1) {
      if (data1 && data1.length) {
        return data1.map(item => ({
          name: item.amountName,
          value: item.percentage
        }));
      } else {
        return []
      }
    },

    //总金额排序
    sortMethod(a, b) {
      return a.totalAmount * 1 > b.totalAmount * 1 ? -1 : 1;
    },

    //可提现金额排序
    sortMethodCanWithdrawAmount(a, b) {
      return a.canWithdrawAmount * 1 > b.canWithdrawAmount * 1 ? -1 : 1;
    },

    //已提现金额排序
    sortMethodWithdrawnAmount(a, b) {
      return a.withdrawnAmount * 1 > b.withdrawnAmount * 1 ? -1 : 1;
    },

    //查看机构/医院/个人明细
    handleSeeIncomeDetails(item) {
      this.incomeItem = item;
      this.incomeDetailsVisible = true;
    },

    //搜索点击
    handleSelect() {
      if (this.validSearch()) {
        this.filterParams.page = 1;
        this.getOrederReportChat();
        this.getOrederReportList();
      }
    },

    handleChangeSharingTimeTab(item, _index) {
			this.resetTimeTabs();
			item.defaultFilter = true;
      this.filterParams.timeSlot = item.timeSlot;
      this.dateRange = [item.begDate, item.endDate]
		},

    handleChangeDate() {
      this.resetTimeTabs();
      this.filterParams.timeSlot = '';
    },

    resetTimeTabs() {
			this.timeTabs.forEach((item) => {
				item.defaultFilter = false;
			})
		},

    handleChangeType() {
      this.$set(this.filterParams, 'attendantNameOrMobile', '')
    },

    validSearch() {
      if (!this.filterParams.incomePersonType) {
        this.$message.error('请勾选收入方');
        return false;
      }

      this.filterParams.begDate = this.dateRange && this.dateRange.length 
				? this.dateUtil.dateFormat(this.dateRange[0]) : '';
			this.filterParams.endDate = this.dateRange && this.dateRange.length 
				? this.dateUtil.dateFormat(this.dateRange[1]) : '';

      if (!this.filterParams.begDate || !this.filterParams.endDate) {
        this.$message.error('请选择交易时间');
        return false;
      }

      return true
    },

    // 导出excel
    async handleExport() {
      let param = {...this.filterParams}
      delete param.page;
      delete param.pageSize;
      if (!this.validSearch()) return;
      let diffDay = this.dateUtil.calcDifference(param.begDate, param.endDate, 'day');
      if (diffDay && diffDay > 30) {
        this.$message({message: '最多可导出一个月！', type: 'warning'});
        return;
      }
      this.loading = true;
      await Util.exportExcel(Constant.URL_EXPORT_INCOME_EXCEL, param);
      this.loading = false;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.getOrederReportList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.getOrederReportList();
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "统计分析", text2: "收入统计" });
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.bk-time-tabs {
	width: auto;
	display: flex;
	align-items: center;
	overflow: hidden;
}

.search-tab {
	text-align: center;
	width: 96px;
	height: 30px;
	line-height: 30px;
	font-size: 14px;
	border-top: 1px solid #D7DDE5;
	border-bottom: 1px solid #D7DDE5;
	border-left: 1px solid #D7DDE5;
}
.search-tab:first-child {
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
}
.search-tab:last-child {
	border-right: 1px solid #D7DDE5;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}
.search-tab-active {
	background-color: #409EFF;
	color: #FFFFFF;

}
.search-tab-inactive {
	background-color: white;
	color: #657180;
}

.report-main {
  margin: 20px 40px;
  display: flex;
  justify-content: space-between;
}

.report-bar {
    flex: 1;
    height: 320px;
    padding-bottom: 20px;
    border-radius: 6px;
    border: 1px solid #D7DDE5;
  }

  .report-main .title {
    padding: 0 0 5px 20px;
    text-align: left;
    height: 45px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 45px;
    border-bottom: 1px solid #D7DDE5;
  }

  .details-text {
    margin-left: 10px; 
    color: #3E7EF5; 
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/IncomeReport.vue